import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated';

interface RequireAuthProps {
  children: React.ReactNode;
  fallbackPath: string;
}

const RequireAuth: React.FC<RequireAuthProps> = ({
  children,
  fallbackPath,
}) => {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={fallbackPath} state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default RequireAuth;
